import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';

const DataTableHeaderCellCheckbox = ({ setCheckedAll, checkedAll }) => {
  return <TableCell style={{ padding: '6px 10px' }}><Checkbox onClick={() => setCheckedAll(!checkedAll)} /></TableCell>;
};

DataTableHeaderCellCheckbox.propTypes = {
  checkedAll: PropTypes.bool,
  setCheckedAll: PropTypes.func,
};

export default DataTableHeaderCellCheckbox;
